//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import proseText from '~/mixins/proseText'
import layout from '~/mixins/layout'
import share from '~/mixins/share.js'

export default {
  mixins: [proseText, layout, share],
  inheritAttrs: false,
  props: {
    title: {
      type: String,
      required: true,
    },
    updatedAt: {
      type: String,
      default: '',
    },
    author: {
      type: Object,
      default() {},
    },
    image: {
      type: Object,
      default() {},
    },
    imageMobile: {
      type: Object,
      default() {},
    },
    content: {
      type: Object,
      default() {},
    },
    nextArticle: {
      type: Object,
      default() {},
    },
    baseUrlToNextArticle: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      required: true,
    },
    itemsBreadcrumb: {
      type: Array,
      default() {},
    },
    tags: {
      type: Array,
      default() {},
    },
    topics: {
      type: Array,
      default() {},
    },
  },
  data() {
    return {
      activeHeading: null,
      manualScrollInProgress: false,
      userSelectedHeading: null,
      headingTexts: [],
      illustrations: [
        {
          number: 1,
          src: require(`~/assets/img/element-connect-08.svg?data`),
          width: 184,
          height: 151,
          alt: '',
        },
        {
          number: 2,
          src: require(`~/assets/img/element-hear-05.svg?data`),
          width: 274,
          height: 184,
          alt: '',
        },
        {
          number: 3,
          src: require(`~/assets/img/element-learn-06.svg?data`),
          width: 222,
          height: 457,
          alt: '',
        },
        {
          number: 4,
          src: require(`~/assets/img/element-connect-07.svg?data`),
          width: 95,
          height: 143,
          alt: '',
        },
        {
          number: 6,
          src: require(`~/assets/img/element-hear-03.svg?data`),
          width: 274,
          height: 262,
          alt: '',
        },
        {
          number: 7,
          src: require(`~/assets/img/element-learn-02.svg?data`),
          width: 157,
          height: 163,
          alt: '',
        },
      ],
    }
  },
  computed: {
    readingTime() {
      return this.$readingTime(this.content?.text)
    },
    defaultUrl() {
      return process.env.baseUrl
        ? process.env.baseUrl + this.$route.path
        : window.location.href
    },
    defaultTitle() {
      return this.$route.meta?.title
    },
  },
  mounted() {
    this.headingTexts = this.createListHeadings(this.content.html)
    const container = this.$refs.runtimeContainer

    if (container && container.nodeType === Node.ELEMENT_NODE) {
      const mutationObserver = new MutationObserver(() => {
        this.updateObserver()
      })
      mutationObserver.observe(container, { childList: true, subtree: true })
      this.updateObserver()
    } else {
      console.error('runtimeContainer is not a valid DOM node:', container)
    }
  },
  methods: {
    updateObserver() {
      this.$nextTick(() => {
        this.observeHeadings()
      })
    },

    observeHeadings() {
      if (!('IntersectionObserver' in window)) {
        console.warn('IntersectionObserver is not supported in this browser.')
        return
      }

      const observer = new IntersectionObserver(
        (entries) => {
          // Filter the intersecting inputs
          const intersectingEntries = entries.filter(
            (entry) => entry.isIntersecting
          )

          if (intersectingEntries.length === 0) {
            return
          }

          // If manual scrolling is in progress
          if (this.manualScrollInProgress) {
            // Check if the observed heading is the one the user selected
            const userHeadingEntry = intersectingEntries.find((entry) => {
              return (
                entry.target.textContent.trim() === this.userSelectedHeading
              )
            })

            if (userHeadingEntry) {
              // The heading selected by the user is visible
              this.activeHeading = this.userSelectedHeading
              // We wait for the scroll to finish in the `scrollToHeadingByText` method, so we don't reset `manualScrollInProgress` here
            }
            // Ignore other inputs while manual scrolling is in progress
            return
          }

          // Find the entry with the largest intersectionRatio
          const mostVisibleEntry = intersectingEntries.reduce(
            (prev, current) => {
              return prev.intersectionRatio > current.intersectionRatio
                ? prev
                : current
            }
          )

          const entryTextContent = mostVisibleEntry.target.textContent.trim()

          // Update activeHeading
          this.activeHeading = entryTextContent
        },
        {
          root: null,
          rootMargin: '-140px 0px -75% 0px',
          threshold: 0,
        }
      )

      this.headingTexts.forEach((topic) => {
        if (topic?.text) {
          const headingEl = this.findHeadingElementByText(topic.text)
          if (headingEl) observer.observe(headingEl)
        }

        topic.subtopics?.forEach((sub) => {
          if (sub) {
            const subEl = this.findHeadingElementByText(sub)
            if (subEl) observer.observe(subEl)
          }
        })
      })
    },

    createListHeadings(htmlContent) {
      if (!htmlContent) return []
      const parser = new DOMParser()
      const doc = parser.parseFromString(htmlContent, 'text/html')
      const headingElements = doc.querySelectorAll('h2, h3')

      const headings = []
      let lastH2 = null
      let hasH2 = false

      headingElements.forEach((heading) => {
        const text = heading.textContent.trim()

        if (heading.tagName === 'H2') {
          hasH2 = true
          lastH2 = { text, subtopics: [] }
          headings.push(lastH2)
        } else if (heading.tagName === 'H3') {
          if (hasH2 && lastH2) {
            lastH2.subtopics.push(text)
          } else {
            headings.push({ text, subtopics: [] })
          }
        }
      })
      return headings
    },

    onHeadingSelected(headingText) {
      this.activeHeading = headingText
      this.manualScrollInProgress = true
      this.userSelectedHeading = headingText

      this.$nextTick(() => {
        this.scrollToHeadingByText(headingText)
      })
    },
    scrollToHeadingByText(headingText) {
      const headingEl = this.findHeadingElementByText(headingText)
      if (headingEl) {
        headingEl.scrollIntoView({ behavior: 'smooth', block: 'start' })
        this.waitForScrollEnd().then(() => {
          // Disables manual scrolling after scrolling is complete
          this.manualScrollInProgress = false
          this.userSelectedHeading = null
        })
      } else {
        console.warn(`Header with text "${headingText}" not found in DOM.`)
      }
    },
    waitForScrollEnd() {
      return new Promise((resolve) => {
        let isScrolling
        const onScroll = () => {
          window.clearTimeout(isScrolling)
          isScrolling = setTimeout(() => {
            window.removeEventListener('scroll', onScroll)
            resolve()
          }, 150)
        }
        window.addEventListener('scroll', onScroll)
      })
    },
    findHeadingElementByText(headingText) {
      if (!headingText) return null

      const headingElements =
        this.$refs.runtimeContainer?.querySelectorAll('h2, h3')
      if (!headingElements) return null

      return Array.from(headingElements).find(
        (el) => el.textContent?.trim() === headingText.trim()
      )
    },
  },
}
